module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/jonathan/Skypager/~/babel-runtime/core-js/object/get-prototype-of.js
// module id = ../../node_modules/babel-runtime/core-js/object/get-prototype-of.js
// module chunks = 0